import { MODAL_ID_DEFAULT } from '../../constants/common'
import { MINIMIZED_MODAL_KEY } from '../Modal'

export const INHABITANT_ACTION_ARCHIVE_ITEM = 'archive_item'

export const INHABITANT_ACTION_ARCHIVE_MASS = 'archive_mass'

export const INHABITANT_ACTION_RESTORE_ITEM = 'restore_item'

export const INHABITANT_ACTION_RESTORE_MASS = 'restore_mass'

export const INHABITANT_ACTION_BLOCK_ITEM = 'block_item'

export const INHABITANT_ACTION_BLOCK_MASS = 'block_mass'

export const INHABITANT_ACTION_UNBLOCK_ITEM = 'unblock_item'

export const INHABITANT_ACTION_UNBLOCK_MASS = 'unblock_mass'

export const INHABITANT_ACTION_EDIT_ROLE_ITEM = 'edit_role_item'

export const INHABITANT_ACTION_EDIT_ROLE_MASS = 'edit_role_mass'

export const INHABITANT_ACTION_SEND_INVITE_ITEM = 'send_invite_item'

export const INHABITANT_ACTION_SEND_INVITE_MASS = 'send_invite_mass'

export const INHABITANT_ACTION_APPROVE_REGISTRATION_ITEM =
  'approve_registration_item'

export const INHABITANT_ACTION_APPROVE_REGISTRATION_MASS =
  'approve_registration_mass'

export const INHABITANT_ACTION_MASS_EMAIL = 'mass_email'

export const INHABITANT_ACTION_CHANGE_ADDRESS = 'change_address'

export const INHABITANT_TABLE_MASS_ACTION_NAMES = {
  [INHABITANT_ACTION_APPROVE_REGISTRATION_ITEM]: 'approve_registration',
  [INHABITANT_ACTION_APPROVE_REGISTRATION_MASS]: 'approve_registration',
  [INHABITANT_ACTION_ARCHIVE_ITEM]: 'archive',
  [INHABITANT_ACTION_ARCHIVE_MASS]: 'archive',
  [INHABITANT_ACTION_BLOCK_ITEM]: 'update_status',
  [INHABITANT_ACTION_BLOCK_MASS]: 'update_status',
  [INHABITANT_ACTION_CHANGE_ADDRESS]: 'change_address',
  [INHABITANT_ACTION_EDIT_ROLE_ITEM]: 'update_role',
  [INHABITANT_ACTION_EDIT_ROLE_MASS]: 'update_role',
  [INHABITANT_ACTION_RESTORE_ITEM]: 'restore',
  [INHABITANT_ACTION_RESTORE_MASS]: 'restore',
  [INHABITANT_ACTION_SEND_INVITE_ITEM]: 'send_invite',
  [INHABITANT_ACTION_SEND_INVITE_MASS]: 'send_invite',
  [INHABITANT_ACTION_UNBLOCK_ITEM]: 'update_status',
  [INHABITANT_ACTION_UNBLOCK_MASS]: 'update_status',
}

export const INHABITANT_TABLE_MODALS_CONFIG = {
  setEmailFormModal: {
    closer: 'closeEmailFormModal',
    id: MINIMIZED_MODAL_KEY.EMAIL_FORM,
  },
  setModal: { closer: 'closeModal', id: MODAL_ID_DEFAULT },
}
